(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1533],{

/***/ 13164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ PrintConfigContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var PrintConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isPrint: false,
    images: {
        lazyloadEnabled: true
    }
});
var PrintConfigProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrintConfigContext.Provider, {
        value: {
            isPrint: true,
            images: {
                lazyloadEnabled: false
            }
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrintConfigProvider);


/***/ }),

/***/ 6498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CloudinaryImage_CloudinaryImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/CloudinaryImage.module.scss
var CloudinaryImage_module = __webpack_require__(82511);
var CloudinaryImage_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryImage_module);
// EXTERNAL MODULE: ./src/integrations/cloudinary/cloudinaryUrlGenerator.ts
var cloudinaryUrlGenerator = __webpack_require__(19470);
// EXTERNAL MODULE: ./node_modules/@cloudinary/react/index.js
var react = __webpack_require__(27410);
// EXTERNAL MODULE: ./node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 35 modules
var resize = __webpack_require__(8045);
// EXTERNAL MODULE: ./node_modules/@cloudinary/url-gen/assets/CloudinaryVideo.js + 1 modules
var CloudinaryVideo = __webpack_require__(91475);
// EXTERNAL MODULE: ./node_modules/use-device-pixel-ratio/dist/index.module.js
var index_module = __webpack_require__(98235);
// EXTERNAL MODULE: ./node_modules/@cloudinary/transformation-builder-sdk/actions/delivery.js + 5 modules
var delivery = __webpack_require__(7984);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app/providers/PrintConfigProvider.tsx
var PrintConfigProvider = __webpack_require__(13164);
;// CONCATENATED MODULE: ./src/components/elements/media/CloudinaryImage/CloudinaryImage.tsx












var CloudinaryImage = function(param) {
    var image = param.image, tmp = param.lazyload, lazyloadOption = tmp === void 0 ? true : tmp, tmp1 = param.responsive, responsiveOption = tmp1 === void 0 ? true : tmp1, tmp2 = param.placeholder, placeholderOption = tmp2 === void 0 ? false : tmp2, width = param.width, height = param.height, _sizeAttributes = param.sizeAttributes, sizeAttributes = _sizeAttributes === void 0 ? false : _sizeAttributes, tmp3 = param.dpr, dprOption = tmp3 === void 0 ? true : tmp3, _cropType = param.cropType, cropType = _cropType === void 0 ? "fill" : _cropType, aspectRatio = param.aspectRatio, titleDefault = param.titleDefault, altDefault = param.altDefault, _className = param.className, className = _className === void 0 ? "" : _className, style = param.style, _placeholderClassName = param.placeholderClassName, placeholderClassName = _placeholderClassName === void 0 ? "" : _placeholderClassName, cld = param.cld, trackingStringClick = param.trackingStringClick, trackingStringDblClick = param.trackingStringDblClick;
    var deviceDpr = (0,index_module/* useDevicePixelRatio */.j)();
    var printConfig = (0,node_modules_react.useContext)(PrintConfigProvider/* PrintConfigContext */.E);
    lazyloadOption = printConfig.images.lazyloadEnabled === false ? false : lazyloadOption;
    if (!(image === null || image === void 0 ? void 0 : image.publicId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((CloudinaryImage_module_default()).placeholder, " ").concat(placeholderClassName)
        });
    }
    if (!cld) {
        cld = cloudinaryUrlGenerator/* default */.Z;
    }
    var mediaFile = image.resourceType === "video" ? cld.video(image.publicId) : cld.image(image.publicId);
    var options = {};
    if (aspectRatio) {
        options.aspect_ratio = aspectRatio;
    }
    mediaFile.format("auto").quality("auto");
    if (dprOption) {
        var imageDpr = Number.isInteger(dprOption) ? dprOption : deviceDpr;
        mediaFile.delivery((0,delivery/* dpr */.uN)(imageDpr + ".0"));
    }
    var cropSettings;
    switch(cropType){
        case "fill":
            cropSettings = (0,resize/* fill */.hl)();
            break;
        case "scale":
            cropSettings = (0,resize/* scale */.bA)();
            break;
    }
    if (!responsiveOption) {
        if (width) {
            cropSettings.width(width);
        }
        if (height) {
            cropSettings.height(height);
        }
    }
    if (aspectRatio) {
        cropSettings.aspectRatio(aspectRatio);
    }
    if (cropType === "fill" && (aspectRatio || width || height)) {
        // @ts-ignore
        cropSettings.gravity("auto");
    }
    mediaFile.resize(cropSettings);
    // see: https://cloudinary.com/documentation/react_image_transformations#plugins
    var plugins = [];
    // placeholder
    // Note: Not using recommended plugin order, as this loads the display image before placeholder image | see: https://cloudinary.com/documentation/react_image_transformations#plugin_order
    if (placeholderOption || lazyloadOption === "placeholder") {
        plugins.push((0,react/* placeholder */.W$)({
            mode: "blur"
        })) // see: https://cloudinary.com/documentation/react_image_transformations#image_placeholders
        ;
    }
    // lazyload
    if (lazyloadOption) {
        plugins.push((0,react/* lazyload */.mA)());
    }
    // responsive breakpoints
    if (responsiveOption) {
        plugins.push((0,react/* responsive */.jW)({
            steps: 200
        }));
    }
    var getSizeAttributes = function() {
        if (sizeAttributes) {
            // custom sizes
            if (width && height) {
                return {
                    width: width,
                    height: height
                };
            }
            // dynamic sizes by aspect ratio
            if (aspectRatio) {
                if (width) {
                    return {
                        width: width,
                        height: width / aspectRatio
                    };
                }
                if (height) {
                    return {
                        width: height * aspectRatio,
                        height: height
                    };
                }
            }
            // intrinsic sizes
            return {
                width: image.width,
                height: image.height
            };
        }
        return {};
    };
    var getTrackingAttributes = function() {
        var trackingAttributes = {};
        // if "trackingStringClick" is set, build "data-tr-click={trackingStringClick}"
        if (trackingStringClick) {
            trackingAttributes["data-tr-click"] = trackingStringClick;
        }
        // if "trackingStringDblClick" is set, build "data-tr-click={trackingStringDblClick}"
        if (trackingStringDblClick) {
            trackingAttributes["data-tr-dblclick"] = trackingStringDblClick;
        }
        return trackingAttributes;
    };
    return function() {
        if ((0,_instanceof/* default */.Z)(mediaFile, CloudinaryVideo/* CloudinaryVideo */._)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* AdvancedVideo */.xl, {
                cldVid: mediaFile,
                poster: mediaFile.toURL(),
                plugins: plugins,
                autoPlay: true,
                loop: true,
                muted: true
            });
        }
        var _title, ref, _description, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* AdvancedImage */.pw, (0,_object_spread/* default */.Z)({
            className: className,
            cldImg: mediaFile,
            plugins: plugins,
            title: (ref = (_title = image.title) !== null && _title !== void 0 ? _title : titleDefault) !== null && ref !== void 0 ? ref : "",
            alt: (ref1 = (_description = image.description) !== null && _description !== void 0 ? _description : altDefault) !== null && ref1 !== void 0 ? ref1 : "",
            loading: lazyloadOption === true ? "lazy" : "auto",
            style: style !== null && style !== void 0 ? style : {}
        }, getSizeAttributes(), getTrackingAttributes()));
    }();
};
/* harmony default export */ var CloudinaryImage_CloudinaryImage = (CloudinaryImage);

;// CONCATENATED MODULE: ./src/components/elements/media/CloudinaryImage/index.ts



/***/ }),

/***/ 38567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_elements_media_CloudinaryImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6498);
/* harmony import */ var _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71064);





var cloudinaryUrlGenerator = new _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_2__/* .Cloudinary */ .r({
    cloud: {
        cloudName: "difp9jq5j"
    },
    url: {
        analytics: false
    }
});
var ThemeImage = function(props) {
    var cropType = props.cropType;
    if (!props.cropType) {
        cropType = "scale";
    }
    var responsive = props.responsive !== undefined ? props.responsive : false;
    var theme = props.theme ? props.theme : "kultour";
    var image = props.image ? props.image : {
        publicId: "themes/".concat(theme, "/").concat(props.src),
        title: props.title,
        description: props.alt
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_media_CloudinaryImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        image: image,
        responsive: responsive,
        cropType: cropType,
        dpr: props.dpr !== undefined ? props.dpr : false,
        cld: cloudinaryUrlGenerator,
        style: props.style ? props.style : {},
        sizeAttributes: true
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ThemeImage);


/***/ }),

/***/ 19470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71064);

var cloudinaryUrlGenerator = new _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_0__/* .Cloudinary */ .r({
    cloud: {
        cloudName: "skag"
    },
    url: {
        analytics: false
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (cloudinaryUrlGenerator);


/***/ }),

/***/ 31533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/themes/kultour/components/template/footer/Footer.module.scss
var Footer_module = __webpack_require__(80232);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/components/template/footer/FooterMenu/FooterMenu.module.scss
var FooterMenu_module = __webpack_require__(9815);
var FooterMenu_module_default = /*#__PURE__*/__webpack_require__.n(FooterMenu_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 4 modules
var Accordion = __webpack_require__(47806);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js
var AccordionButton = __webpack_require__(93621);
;// CONCATENATED MODULE: ./src/components/template/footer/FooterMenu/FooterMenu.tsx







function CustomToggle(param) {
    var children = param.children, eventKey = param.eventKey;
    var ref = (0,react.useState)(false), active = ref[0], setActive = ref[1];
    var decoratedOnClick = (0,AccordionButton/* useAccordionButton */.k)(eventKey, function() {
        setActive(!active);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: "".concat(active && (FooterMenu_module_default()).active, " ").concat((FooterMenu_module_default()).accordionButton),
        onClick: decoratedOnClick,
        children: children
    });
}
var FooterMenu = function(data) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FooterMenu_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((FooterMenu_module_default()).menu, " d-md-none mb-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                    className: (FooterMenu_module_default()).accordion,
                    defaultActiveKey: "1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        className: (FooterMenu_module_default()).accordionItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                                className: (FooterMenu_module_default()).accordionHeader,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomToggle, {
                                    eventKey: "0",
                                    children: data.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Collapse */.Z.Collapse, {
                                eventKey: "0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                    className: (FooterMenu_module_default()).cardBody,
                                    children: data.items && data.items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: data.items.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        "data-tr-click": "footer:navigation_link:click",
                                                        children: item.label
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((FooterMenu_module_default()).menu, " d-none d-md-block"),
                children: [
                    typeof data.title === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FooterMenu_module_default()).title,
                        children: data.title
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: data.title.href,
                        className: (FooterMenu_module_default()).title,
                        "data-tr-click": "footer:navigation_link:click",
                        children: data.title.label
                    }),
                    data.items && data.items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: data.items.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: item.href,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "data-tr-click": "footer:navigation_link:click",
                                        children: item.label
                                    })
                                })
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FooterMenu_FooterMenu = (FooterMenu);

;// CONCATENATED MODULE: ./src/components/template/footer/FooterMenu/index.tsx


// EXTERNAL MODULE: ./src/themes/kultour/components/template/footer/BrandLinks/BrandLinks.module.scss
var BrandLinks_module = __webpack_require__(82894);
var BrandLinks_module_default = /*#__PURE__*/__webpack_require__.n(BrandLinks_module);
// EXTERNAL MODULE: ./src/components/elements/media/ThemeImage/ThemeImage.tsx
var ThemeImage = __webpack_require__(38567);
;// CONCATENATED MODULE: ./src/themes/kultour/components/template/footer/BrandLinks/BrandLinks.tsx





var brands = [
    {
        name: "Surprise Reisen",
        url: "https://www.surprise-reisen.ch",
        logo: {
            src: "/images/logos/logo-surprise-reisen.png",
            // width: 217,
            height: 48,
            style: {
                maxHeight: "48px !important",
                marginBottom: "-11px"
            }
        }
    },
    {
        name: "Kultour Ferienreisen",
        url: "https://www.kultour.ch",
        logo: {
            src: "/images/logos/logo-kultour-white.png",
            // width: 413,
            height: 106
        }
    },
    {
        name: "Carreisen Ostschweiz",
        url: "https://www.carreisen-ostschweiz.ch",
        logo: {
            src: "images/logos/logo-co-carreisen-ostschweiz-white.png",
            // width: 384,
            height: 94
        }
    },
    {
        name: "rex - reisen mit expertise",
        url: "https://rex.tours",
        logo: {
            src: "images/logos/logo-rex.png",
            // width: 361,
            height: 184
        }
    }, 
];
var BrandLinks = function() {
    var t = (0,esm/* useTranslation */.$G)("theme").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
        className: (BrandLinks_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                md: 12,
                lg: {
                    span: 3,
                    offset: 1
                },
                className: "mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                    children: [
                        t("partOfSurpriseKultourAG"),
                        ":"
                    ]
                })
            }),
            brands.map(function(brand, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    xs: 6,
                    md: 3,
                    lg: 2,
                    className: "".concat((BrandLinks_module_default()).item, " align-self-center"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: brand.url,
                        rel: "noreferrer",
                        title: brand.name,
                        "data-tr-click": "footer:brand_logo:click",
                        "data-tr-brand_name": brand.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                            src: brand.logo.src,
                            height: brand.logo.height,
                            alt: brand.name,
                            theme: "kultour",
                            style: brand.logo.style ? brand.logo.style : undefined
                        })
                    })
                }, index);
            })
        ]
    });
};
/* harmony default export */ var BrandLinks_BrandLinks = ((0,esm/* withTranslation */.Zh)([
    "common",
    "theme"
])(BrandLinks));

;// CONCATENATED MODULE: ./src/themes/kultour/components/template/footer/BrandLinks/index.tsx


// EXTERNAL MODULE: ./src/components/template/footer/FooterAddress/FooterAddress.module.scss
var FooterAddress_module = __webpack_require__(79978);
var FooterAddress_module_default = /*#__PURE__*/__webpack_require__.n(FooterAddress_module);
;// CONCATENATED MODULE: ./src/themes/kultour/components/template/footer/FooterAddress/FooterAddress.tsx



var FooterAddress = function(param) {
    var contactBlockSettings = param.contactBlockSettings;
    var phonePrefix = contactBlockSettings.phonePrefix, phone = contactBlockSettings.phone, phone2Prefix = contactBlockSettings.phone2Prefix, phone2 = contactBlockSettings.phone2, email = contactBlockSettings.email;
    var phoneLink = !phone ? phone : "tel:" + phone.replace("(0)", "").split(" ").join("");
    var phone2Link = !phone2 ? phone2 : "tel:" + phone2.replace("(0)", "").split(" ").join("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FooterAddress_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (FooterAddress_module_default()).title,
                        children: "SURPRISE KULTOUR AG"
                    }),
                    "Rudolfstrasse 37",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "8400 Winterthur"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-1",
                        children: [
                            phonePrefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (FooterAddress_module_default()).country,
                                children: [
                                    phonePrefix,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: phoneLink,
                                "data-tr-click": "footer:contact_phone:click",
                                children: phone
                            })
                        ]
                    }),
                    phone2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-1",
                        children: [
                            phone2Prefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (FooterAddress_module_default()).country,
                                children: [
                                    phone2Prefix,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: phone2Link,
                                "data-tr-click": "footer:contact_phone:click",
                                children: phone2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:".concat(email),
                        "data-tr-click": "footer:contact_email:click",
                        children: email
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FooterAddress_FooterAddress = (FooterAddress);

;// CONCATENATED MODULE: ./src/themes/kultour/components/template/footer/FooterAddress/index.tsx


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/template/footer/lib.ts


var buildMenuCols = function(categories) {
    var numberOfCols = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4;
    var bufferFactor = 1.3 // 20% Buffer
    ;
    var menuCols = [];
    // filter out pages with page.onlineStatus === 'ONLINE'
    categories = categories.map(function(category) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, category), {
            pages: category.pages.filter(function(page) {
                return page.onlineStatus === "ONLINE";
            })
        });
    });
    // count pages
    var totalPagesCount = 0;
    categories.map(function(category) {
        totalPagesCount += category.pages.length;
    });
    // spread number of pages evenly over cols
    var colMaxPages = totalPagesCount / numberOfCols;
    var currentColMenus = [];
    var currentColIndex = 0;
    var currentColPagesCount = 0;
    categories.forEach(function(category) {
        if (currentColPagesCount > 0 && currentColPagesCount + category.pages.length > colMaxPages * bufferFactor && currentColIndex + 1 < numberOfCols) {
            menuCols.push(currentColMenus);
            currentColMenus = [];
            currentColIndex += 1;
            currentColPagesCount = 0;
        }
        currentColMenus.push({
            title: category.name,
            items: buildMenuItems(category.seoSettings.urlSlug, category.pages)
        });
        currentColPagesCount += category.pages.length;
    });
    menuCols.push(currentColMenus);
    return menuCols;
};
var buildMenuItems = function(categoryUrlSlug, pages) {
    return pages.map(function(page) {
        return {
            href: "/".concat(categoryUrlSlug, "/").concat(page.seoSettings.urlSlug),
            label: page.name
        };
    });
};

// EXTERNAL MODULE: ./src/components/elements/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(4514);
// EXTERNAL MODULE: ./src/themes/kultour/components/template/footer/FooterTrustLogos/FooterTrustLogos.module.scss
var FooterTrustLogos_module = __webpack_require__(30904);
var FooterTrustLogos_module_default = /*#__PURE__*/__webpack_require__.n(FooterTrustLogos_module);
;// CONCATENATED MODULE: ./src/themes/kultour/components/template/footer/FooterTrustLogos/FooterTrustLogos.tsx




var FooterTrustLogos = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
        className: "".concat((FooterTrustLogos_module_default()).root),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                href: "https://www.srv.ch/",
                rel: "noreferrer",
                "data-tr-click": "footer:trust_icon:click",
                "data-tr-trust_icon_name": "SRV",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                    src: "images/logos/logo-srv.png",
                    height: 37,
                    alt: "SRV Logo",
                    theme: "kultour"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                href: "https://tourcert.org/",
                rel: "noreferrer",
                "data-tr-click": "footer:trust_icon:click",
                "data-tr-trust_icon_name": "TourCert",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                    src: "images/logos/logo-tourcert-white.png",
                    height: 43,
                    alt: "TourCert Logo",
                    theme: "kultour"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                href: "https://www.astag.ch/",
                rel: "noreferrer",
                "data-tr-click": "footer:trust_icon:click",
                "data-tr-trust_icon_name": "ASTAG",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                    src: "images/logos/logo-astag.png",
                    height: 36,
                    alt: "ASTAG Logo",
                    theme: "kultour"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                href: "https://www.garantiefonds.ch/",
                rel: "noreferrer",
                "data-tr-click": "footer:trust_icon:click",
                "data-tr-trust_icon_name": "Reisegarantie",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                    src: "images/logos/logo-reisegarantie-white.png",
                    height: 38,
                    alt: "Reisegarantie Logo",
                    theme: "kultour"
                })
            })
        ]
    });
};
/* harmony default export */ var FooterTrustLogos_FooterTrustLogos = (FooterTrustLogos);

;// CONCATENATED MODULE: ./src/themes/kultour/components/template/footer/FooterTrustLogos/index.tsx


;// CONCATENATED MODULE: ./src/themes/kultour/components/template/footer/Footer.tsx










var Footer = function(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3;
    var menuCols = buildMenuCols(cms.categories, 4);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
            className: (Footer_module_default()).footer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        xs: 12,
                        sm: {
                            span: 8,
                            offset: 2
                        },
                        md: {
                            span: 12,
                            offset: 0
                        },
                        className: "px-4 px-sm-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    menuCols.map(function(col, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            md: 3,
                                            lg: 2,
                                            className: "p-0 p-md-2",
                                            children: col.map(function(menu, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenu_FooterMenu, {
                                                    title: menu.title,
                                                    items: menu.items
                                                }, index);
                                            })
                                        }, index);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        className: "".concat((Footer_module_default()).divider, " mt-0 mt-md-1 d-lg-none")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        md: {
                                            span: 12
                                        },
                                        lg: {
                                            span: 3,
                                            offset: 1,
                                            order: "first"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterAddress_FooterAddress, {
                                                contactBlockSettings: cms.config.contactBlockSettings
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mb-2",
                                                children: [
                                                    ((ref = cms.config) === null || ref === void 0 ? void 0 : (ref1 = ref.socialMediaSettings) === null || ref1 === void 0 ? void 0 : ref1.facebookUrl) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: cms.config.socialMediaSettings.facebookUrl,
                                                        className: (Footer_module_default()).socialLink,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        "data-tr-click": "footer:social_media_icon:click",
                                                        "data-tr-social_media_platform": "facebook",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "visually-hidden-focusable",
                                                                children: "Facebook"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                name: "facebook",
                                                                className: (Footer_module_default()).icon
                                                            })
                                                        ]
                                                    }),
                                                    ((ref2 = cms.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.socialMediaSettings) === null || ref3 === void 0 ? void 0 : ref3.instagramUrl) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: cms.config.socialMediaSettings.instagramUrl,
                                                        className: (Footer_module_default()).socialLink,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        "data-tr-click": "footer:social_media_icon:click",
                                                        "data-tr-social_media_platform": "instagram",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "visually-hidden-focusable",
                                                                children: "Instagram"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                name: "instagram",
                                                                className: (Footer_module_default()).icon
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    className: (Footer_module_default()).divider
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandLinks_BrandLinks, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    className: (Footer_module_default()).divider
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: {
                                            span: 12,
                                            order: "last"
                                        },
                                        md: {
                                            span: 3,
                                            order: "first"
                                        },
                                        lg: {
                                            span: 3,
                                            offset: 1
                                        },
                                        className: "mb-3 mt-3 mt-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                            children: [
                                                "\xa9 ",
                                                new Date().getFullYear(),
                                                " Surprise Kultour AG"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterTrustLogos_FooterTrustLogos, {})
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var footer_Footer = ((0,esm/* withTranslation */.Zh)([
    "common",
    "theme"
])(Footer));

;// CONCATENATED MODULE: ./src/themes/kultour/components/template/footer/index.tsx



/***/ }),

/***/ 82511:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CloudinaryImage_placeholder__kWdxK"};

/***/ }),

/***/ 79978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterAddress_root__ehVQH","title":"FooterAddress_title__wXVFG","subTitle":"FooterAddress_subTitle__IyJ_u","country":"FooterAddress_country__R4SBi"};

/***/ }),

/***/ 9815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterMenu_root__US01R","title":"FooterMenu_title__lUOPc","menu":"FooterMenu_menu__81vNS","accordionHeader":"FooterMenu_accordionHeader__T8LQr","collapsed":"FooterMenu_collapsed__CKz4s","accordionItem":"FooterMenu_accordionItem__HxzNE","unstyledWhite":"FooterMenu_unstyledWhite__ixIBz","accordion":"FooterMenu_accordion__yMOYe","accordionButton":"FooterMenu_accordionButton__vNqeR","active":"FooterMenu_active__VT6a_","cardBody":"FooterMenu_cardBody__hhlGn"};

/***/ }),

/***/ 82894:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandLinks_root__wIy5S","item":"BrandLinks_item__uWD37"};

/***/ }),

/***/ 80232:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__42XiM","title":"Footer_title__jP2QT","socialLink":"Footer_socialLink__w2o_I","icon":"Footer_icon__ZHTGR","divider":"Footer_divider__AEVYY","trustLogos":"Footer_trustLogos___Am_H"};

/***/ }),

/***/ 30904:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterTrustLogos_root__isqrK"};

/***/ }),

/***/ 47806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Collapse.js + 1 modules
var Collapse = __webpack_require__(16518);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js
var AccordionContext = __webpack_require__(88792);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js








/**
 * This component accepts all of [`Collapse`'s props](/utilities/transitions/#collapse-props).
 */
const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext/* default */.Z);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
    ref: ref,
    in: (0,AccordionContext/* isAccordionItemSelected */.T)(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js
var AccordionItemContext = __webpack_require__(54496);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext/* default */.Z);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js
var AccordionButton = __webpack_require__(93621);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionButton/* default */.Z, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: AccordionButton/* default */.Z,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ }),

/***/ 93621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useAccordionButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _AccordionContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88792);
/* harmony import */ var _AccordionItemContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54496);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_AccordionContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_AccordionItemContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_AccordionContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, bsPrefix, !(0,_AccordionContext__WEBPACK_IMPORTED_MODULE_3__/* .isAccordionItemSelected */ .T)(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ __webpack_exports__["Z"] = (AccordionButton);

/***/ }),

/***/ 88792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ isAccordionItemSelected; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ }),

/***/ 54496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  eventKey: ''
});
context.displayName = 'AccordionItemContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 16518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Collapse; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/transitionEndListener.js
var transitionEndListener = __webpack_require__(93825);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs) {
  return funcs.filter(f => f != null).reduce((acc, f) => {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction(...args) {
      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/triggerBrowserReflow.js
var triggerBrowserReflow = __webpack_require__(34509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/TransitionWrapper.js
var TransitionWrapper = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Collapse.js









const MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
  const value = elem[offset];
  const margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[0]), 10) + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[1]), 10);
}

const collapseStyles = {
  [Transition/* EXITED */.Wj]: 'collapse',
  [Transition/* EXITING */.Ix]: 'collapsing',
  [Transition/* ENTERING */.d0]: 'collapsing',
  [Transition/* ENTERED */.cn]: 'collapse show'
};
const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
const Collapse = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  className,
  children,
  dimension = 'height',
  getDimensionValue = getDefaultDimensionValue,
  ...props
}, ref) => {
  /* Compute dimension */
  const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  const handleEnter = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = '0';
  }, onEnter), [computedDimension, onEnter]);
  const handleEntering = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
    elem.style[computedDimension] = `${elem[scroll]}px`;
  }, onEntering), [computedDimension, onEntering]);
  const handleEntered = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onEntered), [computedDimension, onEntered]);
  /* -- Collapsing -- */

  const handleExit = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
    (0,triggerBrowserReflow/* default */.Z)(elem);
  }, onExit), [onExit, getDimensionValue, computedDimension]);
  const handleExiting = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onExiting), [computedDimension, onExiting]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
    ref: ref,
    addEndListener: transitionEndListener/* default */.Z,
    ...props,
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: children.ref,
    children: (state, innerProps) => /*#__PURE__*/react.cloneElement(children, { ...innerProps,
      className: classnames_default()(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
    })
  });
}); // @ts-ignore

// @ts-ignore
Collapse.defaultProps = defaultProps;
/* harmony default export */ var esm_Collapse = (Collapse);

/***/ })

}]);